import { useState, type FC } from 'react'
import MTDLogoBlack from '~/assets/MTD-logo-black.svg'
import MTDLogoWhite from '~/assets/MTD-logo-white.svg'
import BurgerIcon from '~/assets/burgermenu.svg'
import { useAuth } from '@lib/hooks'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Navigation } from '~/navigation/navigation'
import { HeaderTestIds } from '@lib/testing'
import { MTDtracking } from '@shamaazi/mytennights'
import { isWidget } from '@lib/services'

export const Header: FC = () => {
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [active, setActive] = useState(false)
  const displayMenuPaths = [Navigation.home()]
  const currentPath = location.pathname
  // Menu on home page and my profile urls
  const displayMenu = displayMenuPaths.some(path => path === currentPath) || currentPath.startsWith('/account')

  return <>
    <header className={`flex flex-row h-16 p-4 font-normal text-fg-menu-item shadow-lg md:px-20 items-center ${currentPath === Navigation.home() ? 'bg-mtd-secondary-2' : 'bg-fg-blue-320'} ${displayMenu ? 'justify-between' : 'justify-center'}`}>
      <img src={currentPath === Navigation.home() ? MTDLogoBlack : MTDLogoWhite} alt='MTD logo' className={`h-5 my-2 ${!isWidget ? 'cursor-pointer' : ''} stroke-white`} onClick={() => !isWidget ? navigate(Navigation.home()) : null} />
      {/* DESKTOP */}
      {displayMenu && <>
        <div className="hidden md:block">
          {!user ? (
            <Link to={Navigation.accountSchedules()} className="text-sm text-mtd-black font-bold">LOGIN</Link>
          ) : (
            <>
            <Link to={Navigation.home()} className={`text-sm ${currentPath === Navigation.home() ? 'text-mtd-black' : 'text-white'} font-bold`} onClick={logout}>LOGOUT</Link>
            <Link
              data-test-id={HeaderTestIds.myProfile}
              className={`ml-6 text-sm ${currentPath === Navigation.home() ? 'text-mtd-black' : 'text-white'} font-bold`}
              to="/account/schedules"
              onClick={() => {
                MTDtracking.myProfile(user?.email)
              }}
            >
              MY PROFILE
            </Link>
            </>
          )}
        </div>

        <div className={`md:hidden ml-auto tham tham-e-squeeze tham-w-8 my-2 ${active ? 'tham-active' : ''}`}
          onClick={() => setActive(!active)}>
          {<img alt='burger-icon' src={BurgerIcon} width={38}></img>}
        </div>
      </>}
    </header>

    {/* Menu for mobile */}
    {<div onClick={() => setActive(false)}
      className={`md:hidden overflow-y-scroll bg-white text-center px-8 fixed min-h-screen w-full z-40 font-medium transform transition-all duration-500 left-full top-16 ${active ? '-translate-x-full' : ''}`}>
      <div className='flex flex-col py-4 gap-y-4'>
        {!user ? (
          <Link to={Navigation.accountSchedules()} className="text-lg text-mtd-black font-bold">LOGIN</Link>
        ) : (
          <>
            <Link to={Navigation.home()} className="text-lg text-mtd-black font-bold" onClick={logout}>LOGOUT</Link>
            <Link
              data-test-id={HeaderTestIds.myProfile}
              className="ml-3 text-lg text-mtd-black font-bold"
              to="/account/schedules"
              onClick={() => {
                MTDtracking.myProfile(user?.email)
              }}
            >
              MY PROFILE
            </Link>
          </>
        )}
      </div>
    </div>}
  </>
}
